import { resetSearchStore } from '../actions/internalActions';
import { endSearchSession, searchSessionEnded } from '../actions/publicActions';
import { getStore } from '../store/store';
import { lazyFlushNonRenderedItemsFromCache, lazyLogSessionEnd } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
export default orchestrator(endSearchSession, function () {
    var searchStore = getStore();
    var searchSessionGuid = searchStore.searchSessionGuid;
    var latestTraceId = searchStore.latestTraceId;
    // Throw if user isn't already in a search session.
    if (!searchSessionGuid) {
        throw new Error('searchSessionGuid should be set when ending a search session.');
    }
    // Dispatch action to reset store (after getting values from it).
    resetSearchStore();
    /**
     * If using 3S, log instrumentation to end session, and flush any
     * non-rendered events from the event cache.
     */
    if (getStore().isUsing3S) {
        lazyLogSessionEnd.importAndExecute(latestTraceId, new Date());
        // Flush 3S telemetry events from cache.
        lazyFlushNonRenderedItemsFromCache.importAndExecute();
    }
    /**
     * After common "end session" work is done, dispatch event to notify
     * consumer that search session has ended.
     */
    searchSessionEnded(searchSessionGuid);
});
//# sourceMappingURL=endSearchSessionOrchestrator.js.map